import { CheckrStatusResults } from '../../../../../constants'
import { IDVStatus, successIdvStatuses } from '../../../../../utilities/steps'
import { progressionCheckStepNames } from '../constants'

// Gets the active step index number
export const getActiveStep = (
  isOrientationEnabled: boolean,
  scheduledOrientation: {
    startTime: string
    address: string
  },
  idvStatus: IDVStatus,
  identityVerificationStatus: IDVStatus,
  backgroundCheck: CheckrStatusResults
): string => {
  const isIdentityVerified =
    successIdvStatuses.includes(idvStatus) &&
    successIdvStatuses.includes(identityVerificationStatus)
  if (!isIdentityVerified) {
    return progressionCheckStepNames.VERIFY_IDENTITY_STEP
  }

  const hasScheduledOrientation =
    scheduledOrientation &&
    scheduledOrientation.startTime &&
    scheduledOrientation.address
  if (isOrientationEnabled && !hasScheduledOrientation) {
    return progressionCheckStepNames.SCHEDULE_ORIENTATION_STEP
  }

  const clearedBackgroundCheck = backgroundCheck === CheckrStatusResults.Clear
  if (!clearedBackgroundCheck) {
    return progressionCheckStepNames.CONFIRM_ACTIVATION_STEP
  }

  return progressionCheckStepNames.COMPLETE_DELIVERY_STEP
}
